import {
  ALTERA_PERSONALIZACAO_REQUEST,
  ALTERA_PERSONALIZACAO_SUCCESS,
  RECUPERA_PERSONALIZACAO_REQUEST,
  RECUPERA_PERSONALIZACAO_SUCCESS,
} from './constants';

export function alterarPersonalizacaoRequest(values) {
  return {
    type: ALTERA_PERSONALIZACAO_REQUEST,
    values,
  };
}

export function alterarPersonalizacaoSuccess(values) {
  return {
    type: ALTERA_PERSONALIZACAO_SUCCESS,
    values,
  };
}

export function recuperaPersonalizacaoRequest(values) {
  return {
    type: RECUPERA_PERSONALIZACAO_REQUEST,
    values,
  };
}

export function recuperaPersonalizacaoSuccess(values) {
  return {
    type: RECUPERA_PERSONALIZACAO_SUCCESS,
    values,
  };
}
